(function () {
  'use strict';

  var config = window.VenucastSolutionFinderConfig;
  if (!config) return;

  document.querySelectorAll('[data-solution-finder]').forEach(initFinder);

  function initFinder(root) {
    var storageKey = 'venucast_solution_finder_v4';
    var loadedProducts = {};
    var state = {
      answers: {},
      currentIndex: 0,
      started: false,
      completed: false,
      rule: null,
      category: '',
      presetUseCase: '',
      attemptId: ''
    };

    var tool = root.querySelector('[data-finder-tool]');
    var questionCard = root.querySelector('[data-finder-question-card]');
    var questionHost = root.querySelector('[data-finder-question]');
    var resultHost = root.querySelector('[data-finder-result]');
    var progressBar = root.querySelector('[data-finder-progress-bar]');
    var progressLabel = root.querySelector('[data-finder-progress-label]');
    var contextBadge = root.querySelector('[data-finder-context]');
    var startButton = root.querySelector('[data-finder-start]');
    var startActions = root.querySelector('[data-finder-start-actions]');
    var logEndpoint = normalizeEndpoint(root.getAttribute('data-log-endpoint'));
    var params = new URLSearchParams(window.location.search);

    state.presetUseCase = normalizeUseCase(params.get('use_case'));
    state.category = normalizeTextParam(params.get('category'));

    restoreSession();
    if (state.presetUseCase || state.category) {
      state.answers = state.presetUseCase ? { useCase: state.presetUseCase } : {};
      state.currentIndex = 0;
      state.started = false;
      state.attemptId = '';
    }

    startButton.addEventListener('click', function () { startFinder(false, 'hero'); });
    root.querySelectorAll('[data-finder-help]').forEach(function (link) {
      link.addEventListener('click', function () {
        track('solution_finder_cta_clicked', {
          cta_type: link.getAttribute('data-finder-help'),
          recommended_setup: state.rule ? state.rule.id : '',
          result: state.completed ? 'recommendation_generated' : 'finder_help'
        });
      });
    });

    window.addEventListener('beforeunload', function () {
      if (!state.started || state.completed) return;
      var flow = getFlow();
      var currentQuestion = flow[state.currentIndex] || 'unknown';
      track('solution_finder_abandoned', {
        stuck_at_question: currentQuestion,
        completed_answers: Object.keys(state.answers).filter(function (key) { return key !== 'notes'; }).join(',') || 'none'
      }, true);
    });

    if (state.presetUseCase) {
      startFinder(true, 'context');
    } else if (state.started && Object.keys(state.answers).length) {
      showResumeState();
    }

    function startFinder(fromContext, source) {
      if (!state.started) {
        state.started = true;
        state.attemptId = state.attemptId || newAttemptId();
        track('solution_finder_started', {
          start_source: source,
          entry_page: window.location.pathname + window.location.search,
          use_case: state.answers.useCase || '',
          category: state.category || ''
        });
      }

      startActions.hidden = true;
      tool.hidden = false;
      resultHost.hidden = true;
      questionCard.hidden = false;
      state.currentIndex = fromContext || state.presetUseCase ? 0 : state.currentIndex;
      setContextBadge();
      renderQuestion();
      saveSession();
      scrollToTool();
    }

    function showResumeState() {
      startButton.textContent = 'Continue My Setup';
    }

    function getFlow() {
      var flow = [];
      if (!state.presetUseCase) flow.push('useCase');
      flow.push('venueCapacity', 'adaCompliance');
      if (state.answers.adaCompliance !== 'yes') flow.push('listenerCount');
      flow.push('listeningMethod');
      if (Array.isArray(state.answers.listeningMethod) && state.answers.listeningMethod.indexOf('hearing_aids') !== -1) flow.push('hearingAidType');
      flow.push('audioSource', 'barriers');
      return flow;
    }

    function renderQuestion() {
      var flow = getFlow();
      if (state.currentIndex >= flow.length) {
        generateRecommendation();
        return;
      }

      var key = flow[state.currentIndex];
      var progress = Math.round(((state.currentIndex + 1) / flow.length) * 100);
      progressBar.style.width = progress + '%';
      progressLabel.textContent = (state.currentIndex + 1) + ' of ' + flow.length;

      if (key === 'venueCapacity') {
        renderCapacityQuestion(key);
        return;
      }

      var question = getQuestion(key);
      var currentAnswer = state.answers[key];
      var isMultiple = key === 'listeningMethod';
      var optionsMarkup = question.options.map(function (option) {
        var selected = isMultiple
          ? Array.isArray(currentAnswer) && currentAnswer.indexOf(option.value) !== -1
          : currentAnswer === option.value;
        return '<button type="button" class="sf-option' + (selected ? ' is-selected' : '') + '" data-answer="' + option.value + '" aria-pressed="' + (selected ? 'true' : 'false') + '">' +
          (option.icon ? '<span class="sf-option__icon" aria-hidden="true">' + option.icon + '</span>' : '') +
          '<span class="sf-option__content"><span class="sf-option__label">' + option.label + '</span>' +
          (option.description ? '<span class="sf-option__description">' + option.description + '</span>' : '') + '</span>' +
          '</button>';
      }).join('');

      questionHost.innerHTML =
        '<h2>' + question.title + '</h2>' +
        (question.helper ? '<p class="sf-question__helper">' + question.helper + '</p>' : '') +
        (question.preview || '') +
        '<div class="sf-options" role="group" aria-label="' + question.title + '">' + optionsMarkup + '</div>' +
        '<div class="sf-question__actions">' +
          '<button type="button" class="sf-back" data-finder-back' + (state.currentIndex === 0 ? ' hidden' : '') + '>← Back</button>' +
          (isMultiple ? '<button type="button" class="sf-button sf-button--primary" data-finder-continue' + (!Array.isArray(currentAnswer) || !currentAnswer.length ? ' disabled' : '') + '>Continue</button>' : '<span></span>') +
        '</div>';

      questionHost.querySelectorAll('[data-answer]').forEach(function (button) {
        button.addEventListener('click', function () {
          var value = button.getAttribute('data-answer');
          if (isMultiple) {
            updateMultipleAnswer(key, value);
            renderQuestion();
            return;
          }
          state.answers[key] = value;
          clearDependentAnswers(key);
          recordAnswer(key, value);
          state.currentIndex += 1;
          saveSession();
          renderQuestion();
        });
      });

      bindBackButton();
      var continueButton = questionHost.querySelector('[data-finder-continue]');
      if (continueButton) {
        continueButton.addEventListener('click', function () {
          if (!state.answers[key] || !state.answers[key].length) return;
          recordAnswer(key, state.answers[key]);
          state.currentIndex += 1;
          saveSession();
          renderQuestion();
        });
      }
    }

    function renderCapacityQuestion(key) {
      var current = typeof state.answers[key] === 'number' ? state.answers[key] : '';
      questionHost.innerHTML =
        '<h2>What is the venue’s maximum seating or audience capacity?</h2>' +
        '<p class="sf-question__helper">Enter the largest audience expected in this listening area. We use this to match published product range and show an ADA planning quantity.</p>' +
        '<form class="sf-capacity" data-capacity-form novalidate>' +
          '<label for="FinderCapacity-' + root.getAttribute('data-section-id') + '">Maximum people or seats</label>' +
          '<input id="FinderCapacity-' + root.getAttribute('data-section-id') + '" type="number" inputmode="numeric" min="1" max="100000" step="1" value="' + current + '" placeholder="Example: 300" data-capacity-input>' +
          '<p class="sf-capacity__error" data-capacity-error hidden>Please enter a whole number from 1 to 100,000.</p>' +
          '<div class="sf-capacity__buttons">' +
            '<button type="submit" class="sf-button sf-button--primary">Continue</button>' +
            '<button type="button" class="sf-button sf-button--secondary" data-capacity-unknown>I’m not sure</button>' +
          '</div>' +
        '</form>' +
        '<div class="sf-question__actions"><button type="button" class="sf-back" data-finder-back' + (state.currentIndex === 0 ? ' hidden' : '') + '>← Back</button><span></span></div>';

      var form = questionHost.querySelector('[data-capacity-form]');
      var input = questionHost.querySelector('[data-capacity-input]');
      var error = questionHost.querySelector('[data-capacity-error]');
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        var value = Number(input.value);
        if (!Number.isInteger(value) || value < 1 || value > 100000) {
          error.hidden = false;
          input.setAttribute('aria-invalid', 'true');
          input.focus();
          return;
        }
        state.answers[key] = value;
        recordAnswer(key, value);
        state.currentIndex += 1;
        saveSession();
        renderQuestion();
      });
      input.addEventListener('input', function () {
        error.hidden = true;
        input.removeAttribute('aria-invalid');
      });
      questionHost.querySelector('[data-capacity-unknown]').addEventListener('click', function () {
        state.answers[key] = 'not_sure';
        recordAnswer(key, 'not_sure');
        state.currentIndex += 1;
        saveSession();
        renderQuestion();
      });
      bindBackButton();
    }

    function bindBackButton() {
      var backButton = questionHost.querySelector('[data-finder-back]');
      if (!backButton) return;
      backButton.addEventListener('click', function () {
        state.currentIndex = Math.max(0, state.currentIndex - 1);
        renderQuestion();
      });
    }

    function getQuestion(key) {
      var useCase = state.answers.useCase;
      if (key === 'useCase') return { title: 'What are you trying to do?', options: config.useCases };
      if (key === 'adaCompliance') {
        var capacity = state.answers.venueCapacity;
        var preview = '';
        if (typeof capacity === 'number') {
          var counts = getAdaCounts(capacity);
          preview = '<aside class="sf-ada-preview"><span class="sf-ada-preview__icon" aria-hidden="true">♿</span><div><strong>' + capacity.toLocaleString() + ' seats → ADA reference: ' + counts.receivers + ' receivers</strong><p>' + getAdaCalculation(capacity, counts.receivers) + '. Includes ' + counts.hearingAidCompatible + ' hearing-aid-compatible receivers when an assistive listening system is required.</p><p><strong>Choose ADA planning to use this capacity target and skip the separate expected-device question.</strong></p></div></aside>';
        }
        return {
          title: 'Do you need this system for ADA planning?',
          helper: typeof capacity === 'number' ? 'Choose how the recommendation should use the capacity-based ADA reference.' : 'Without a seat count, we can size products only from expected demand.',
          preview: preview,
          options: config.adaComplianceOptions
        };
      }
      if (key === 'listenerCount') {
        var isGroup = useCase === 'silent_event' || useCase === 'guided_tour';
        return {
          title: isGroup ? 'How many people need a venue-provided listening device?' : 'How many venue-provided listening devices do you expect to hand out?',
          helper: isGroup ? '' : 'Do not count visitors using their own compatible devices. The ADA planning note may show a higher minimum based on venue capacity.',
          options: isGroup ? config.listenerCounts.group : config.listenerCounts.standard
        };
      }
      if (key === 'listeningMethod') {
        return { title: 'How will people listen or access the audio?', helper: 'Choose all that apply.', options: config.listeningMethods };
      }
      if (key === 'hearingAidType') {
        return { title: 'What best describes the hearing aids your visitors may use?', helper: 'You do not need to know the brand or wireless technology. Choose the closest answer.', options: config.hearingAidTypes };
      }
      if (key === 'audioSource') {
        var allowed = config.sourceOptionsByUseCase[useCase];
        return {
          title: 'What audio source do you have?',
          options: allowed ? config.audioSources.filter(function (option) { return allowed.indexOf(option.value) !== -1; }) : config.audioSources
        };
      }
      return { title: 'Are there walls, separation or multiple listening areas?', helper: 'Wireless range is normally published for line-of-sight use. Concrete, people and interference can reduce usable coverage.', options: config.barriers };
    }

    function updateMultipleAnswer(key, value) {
      var selected = Array.isArray(state.answers[key]) ? state.answers[key].slice() : [];
      if (value === 'not_sure') {
        selected = selected.length === 1 && selected[0] === value ? [] : [value];
      } else {
        selected = selected.filter(function (item) { return item !== 'not_sure'; });
        var index = selected.indexOf(value);
        if (index === -1) selected.push(value);
        else selected.splice(index, 1);
      }
      state.answers[key] = selected;
      if (key === 'listeningMethod' && selected.indexOf('hearing_aids') === -1) delete state.answers.hearingAidType;
      saveSession();
    }

    function clearDependentAnswers(key) {
      if (key === 'adaCompliance' && state.answers.adaCompliance === 'yes') {
        delete state.answers.listenerCount;
        return;
      }
      if (key === 'useCase') {
        delete state.answers.venueCapacity;
        delete state.answers.adaCompliance;
        delete state.answers.listenerCount;
        delete state.answers.listeningMethod;
        delete state.answers.hearingAidType;
        delete state.answers.audioSource;
        delete state.answers.barriers;
      }
    }

    function recordAnswer(key, value) {
      track('solution_finder_answered', {
        question: key,
        answer: Array.isArray(value) ? value.join(',') : value,
        next_question: getFlow()[state.currentIndex + 1] || 'complete',
        entry_page: window.location.pathname + window.location.search,
        use_case: state.answers.useCase || ''
      });
    }

    function generateRecommendation() {
      var rules = config.rules.filter(function (rule) { return rule.enabled; }).slice().sort(function (a, b) { return b.priority - a.priority; });
      state.rule = rules.find(ruleMatches) || null;
      if (!state.rule) return;

      state.completed = true;
      questionCard.hidden = true;
      resultHost.hidden = false;
      renderResult(state.rule);
      saveSession();

      track('solution_finder_recommendation', {
        recommended_setup: state.rule.id,
        recommended_products: getRecommendedProductIds(state.rule).join(','),
        use_case: state.answers.useCase || '',
        venue_capacity: state.answers.venueCapacity || '',
        ada_receiver_target: getAdaReceiverTarget() || '',
        listener_count: state.answers.listenerCount || '',
        audio_source: state.answers.audioSource || '',
        barriers: state.answers.barriers || '',
        listening_method: Array.isArray(state.answers.listeningMethod) ? state.answers.listeningMethod.join(',') : '',
        hearing_aid_type: getHearingAidProfile(),
        ada_planning: state.answers.adaCompliance || ''
      });

      updateHelpLinks();
      fetchRecommendedProducts();
      scrollToTool();
    }

    function ruleMatches(rule) {
      return conditionSetMatches(rule.conditions || {});
    }

    function conditionSetMatches(conditions) {
      if (conditions.any && !conditions.any.some(conditionSetMatches)) return false;
      return Object.keys(conditions).filter(function (key) { return key !== 'any'; }).every(function (key) {
        if (key === 'minVenueCapacity') return typeof state.answers.venueCapacity === 'number' && state.answers.venueCapacity >= conditions[key];
        if (key === 'maxVenueCapacity') return typeof state.answers.venueCapacity === 'number' && state.answers.venueCapacity <= conditions[key];
        var allowed = conditions[key];
        if (!allowed || !allowed.length) return true;
        var answer = state.answers[key];
        if (Array.isArray(answer)) return answer.some(function (value) { return allowed.indexOf(value) !== -1; });
        return allowed.indexOf(answer) !== -1;
      });
    }

    function renderResult(rule) {
      var groups = getResultGroups(rule);

      resultHost.innerHTML =
        '<div class="sf-result__heading"><p class="sf-result__intro">Your setup plan</p><button class="sf-restart" type="button" data-finder-restart>Start Over</button></div>' +
        '<article class="sf-result-summary">' +
          '<span class="sf-result-summary__icon" aria-hidden="true">✓</span>' +
          '<div><h2>Your requirements</h2><p>' + buildRequirementsSummary() + '</p></div>' +
        '</article>' +
        renderAdaGuidance() +
        '<div class="sf-product-groups">' +
          renderProductGroup('Recommended transmitter', 'transmitter', groups.transmitter) +
          renderProductGroup('Recommended receivers & listening devices', 'receivers', groups.receivers) +
          renderProductGroup('Recommended accessories', 'accessories', groups.accessories) +
        '</div>' +
        '<div class="sf-result__actions">' +
          '<button class="sf-button sf-button--primary" type="button" data-add-all disabled>Preparing cart…</button>' +
          '<a class="sf-button sf-button--secondary" href="' + advisorUrl() + '" data-result-cta="expert_email">Confirm With an Expert by Email</a>' +
        '</div>' +
        '<p class="sf-cart-note" data-cart-status aria-live="polite">Items with a quantity that needs confirmation will be added as quantity 1 so you can review them in the cart.</p>' +
        '<div class="sf-notes"><label for="FinderNotes-' + root.getAttribute('data-section-id') + '">Anything unusual about your setup?</label>' +
          '<textarea id="FinderNotes-' + root.getAttribute('data-section-id') + '" data-finder-notes placeholder="Example: We have a 300-seat church, concrete side rooms and an Allen & Heath mixer."></textarea>' +
        '</div>';

      var notes = resultHost.querySelector('[data-finder-notes]');
      notes.value = state.answers.notes || '';
      notes.addEventListener('input', function () {
        state.answers.notes = notes.value;
        saveSession();
        updateHelpLinks();
        var advisor = resultHost.querySelector('[data-result-cta="expert_email"]');
        if (advisor) advisor.href = advisorUrl();
      });

      resultHost.querySelector('[data-finder-restart]').addEventListener('click', restart);
      resultHost.querySelector('[data-add-all]').addEventListener('click', function () { addAllToCart(groups); });
      resultHost.querySelectorAll('[data-result-cta], [data-product-link]').forEach(function (link) {
        link.addEventListener('click', function () {
          track('solution_finder_cta_clicked', {
            cta_type: link.getAttribute('data-result-cta') || 'product_detail',
            product_id: link.getAttribute('data-product-link') || '',
            result: rule.id
          });
        });
      });
    }

    function getResultGroups(rule) {
      var base = rule.recommendation.groups;
      var groups = {
        transmitter: (base.transmitter || []).slice(),
        receivers: (base.receivers || []).slice(),
        accessories: (base.accessories || []).slice()
      };
      var methods = Array.isArray(state.answers.listeningMethod) ? state.answers.listeningMethod : [];
      var hearingAidProfile = getHearingAidProfile();
      var needsTelecoilPlan = hearingAidProfile === 'older' || hearingAidProfile === 'mixed' || hearingAidProfile === 'not_sure';
      if (needsTelecoilPlan && !hasProduct(groups, 'tcoil_390')) {
        groups.receivers.push({
          productId: 'tcoil_390',
          quantity: 'hearingAidProfileTelecoilPacks',
          reason: 'Because the exact hearing-aid technology is older, mixed or unknown, this pack provides three AuraCoil neck loop receivers for visitors whose hearing aids use T-Coil / telecoil.'
        });
      }
      if (methods.indexOf('own_bluetooth') !== -1 || methods.indexOf('captions') !== -1) {
        var reasons = [];
        if (methods.indexOf('own_bluetooth') !== -1) reasons.push('personal Bluetooth earbuds');
        if (methods.indexOf('captions') !== -1) reasons.push('the phone caption display');
        groups.accessories.push({ productId: 'c83', quantity: 'perUser', reason: 'Standard Bluetooth devices do not join an Auracast broadcast directly. Aura C lets a phone receive the venue broadcast and pass the audio to ' + joinReadable(reasons) + '.' });
      }
      Object.keys(groups).forEach(function (key) {
        groups[key] = groups[key].filter(function (item) { return resolveQuantity(item.quantity) !== '0'; });
      });
      return groups;
    }

    function hasProduct(groups, productId) {
      return groups.transmitter.concat(groups.receivers, groups.accessories).some(function (item) { return item.productId === productId; });
    }

    function renderProductGroup(title, key, items) {
      var body = items.length
        ? items.map(renderProductCard).join('')
        : '<p class="sf-product-group__empty">No additional product was triggered by your answers. Confirm cabling and charging during installation planning.</p>';
      return '<section class="sf-product-group sf-product-group--' + key + '"><div class="sf-product-group__heading"><span aria-hidden="true">' + groupIcon(key) + '</span><div><h3>' + title + '</h3><p>' + getGroupWhy(key) + '</p></div></div><div class="sf-product-list">' + body + '</div></section>';
    }

    function renderProductCard(item) {
      var product = config.products[item.productId];
      return '<article class="sf-product-card" data-product-card="' + item.productId + '">' +
        '<a class="sf-product-card__media" href="/products/' + product.handle + '" data-product-link="' + item.productId + '"><img data-product-image hidden alt=""></a>' +
        '<div class="sf-product-card__body">' +
          '<div class="sf-product-card__top"><h4 data-product-title>' + product.fallbackTitle + '</h4><span class="sf-product-card__quantity">Qty: ' + resolveQuantity(item.quantity) + '</span></div>' +
          '<p>' + item.reason + '</p>' +
          '<div class="sf-product-card__footer"><strong data-product-price aria-live="polite"></strong><a href="/products/' + product.handle + '" data-product-link="' + item.productId + '">View product →</a></div>' +
        '</div>' +
      '</article>';
    }

    function renderAdaGuidance() {
      var capacity = state.answers.venueCapacity;
      if (typeof capacity !== 'number') {
        return '<aside class="sf-ada"><div><span>ADA capacity reference</span><h3>Seat count needed</h3></div><div><p>Covered assembly areas use seating capacity to determine the receiver reference. Enter the maximum seat count or confirm the requirement with an expert.</p><a href="https://www.ada.gov/law-and-regs/design-standards/2010-stds/#219-assistive-listening-systems" target="_blank" rel="noopener">Read ADA sections 219 and 706</a></div></aside>';
      }
      var counts = getAdaCounts(capacity);
      var listener = findListenerOption(state.answers.listenerCount);
      var demand = listener ? listener.label : 'not specified';
      var sizingCopy = state.answers.adaCompliance === 'yes'
        ? 'Receiver-pack sizing uses this capacity reference. Sellable receiver packs may provide slightly more than the exact minimum.'
        : 'Receiver-pack sizing uses your expected venue-device demand (' + demand + '); the ADA number stays visible as a separate reference.';
      return '<aside class="sf-ada"><div><span>ADA capacity reference</span><h3>' + capacity.toLocaleString() + ' seats → ' + counts.receivers + ' receivers</h3><p class="sf-ada__calculation">' + getAdaCalculation(capacity, counts.receivers) + '</p><p class="sf-ada__compatible">Includes ' + counts.hearingAidCompatible + ' hearing-aid-compatible receivers</p></div>' +
        '<div><p>Table 219.3 provides this minimum when an assistive listening system is required for the assembly area. <strong>' + sizingCopy + '</strong></p><p class="sf-ada__disclaimer">Requirements and exceptions depend on the facility. Verify federal, state and local obligations; this is general planning guidance, not legal advice.</p><a href="https://www.ada.gov/law-and-regs/design-standards/2010-stds/#219-assistive-listening-systems" target="_blank" rel="noopener">Read ADA sections 219 and 706</a></div></aside>';
    }

    function getAdaCounts(capacity) {
      var receivers;
      var compatible;
      if (capacity <= 50) {
        receivers = 2;
        compatible = 2;
      } else if (capacity <= 500) {
        receivers = 2 + Math.ceil((capacity - 50) / 25);
        compatible = capacity <= 200 ? 2 : Math.ceil(receivers / 4);
      } else if (capacity <= 1000) {
        receivers = 20 + Math.ceil((capacity - 500) / 33);
        compatible = Math.ceil(receivers / 4);
      } else if (capacity <= 2000) {
        receivers = 35 + Math.ceil((capacity - 1000) / 50);
        compatible = Math.ceil(receivers / 4);
      } else {
        receivers = 55 + Math.ceil((capacity - 2000) / 100);
        compatible = Math.ceil(receivers / 4);
      }
      return { receivers: receivers, hearingAidCompatible: compatible };
    }

    function getAdaCalculation(capacity, receivers) {
      if (capacity <= 50) return '2 receivers for 50 seats or fewer';
      if (capacity <= 500) return '2 + 1 for every 25 seats over 50 = ' + receivers;
      if (capacity <= 1000) return '20 + 1 for every 33 seats over 500 = ' + receivers;
      if (capacity <= 2000) return '35 + 1 for every 50 seats over 1,000 = ' + receivers;
      return '55 + 1 for every 100 seats over 2,000 = ' + receivers;
    }

    function resolveQuantity(quantity) {
      if (typeof quantity === 'number') return String(quantity);
      if (quantity === 'sitePlan') return 'Confirm from site plan';
      if (quantity === 'perUser') return '1 per user / display';
      if (quantity === 'adaM3StandardPacks3') return String(getM3AdaPlan().standardPacks);
      if (quantity === 'adaM3TelecoilPacks3') return String(getM3AdaPlan().telecoilPacks);
      if (quantity === 'hearingAidProfileTelecoilPacks') return '1';
      if (quantity === 'adaTelecoilKits') {
        var capacity = state.answers.venueCapacity;
        return state.answers.adaCompliance === 'yes' && typeof capacity === 'number' ? String(Math.max(1, Math.ceil(getAdaCounts(capacity).hearingAidCompatible / 3))) : '1 per 3 T-Coil users';
      }
      if (quantity === 'receiverPacks10') {
        var required = getRecommendedReceiverCount();
        return required ? String(Math.ceil(required / 10)) : 'Confirm';
      }
      if (quantity === 'groupPacks10') return resolveGroupPacks(10);
      if (quantity === 'groupPacks6') return resolveGroupPacks(6);
      if (quantity === 'quartetExtras') {
        var listeners = getListenerQuantity();
        return listeners ? String(Math.max(0, listeners - 4)) : 'Confirm';
      }
      if (quantity === 'quartetCharging') return 'Confirm';
      return 'Confirm';
    }

    function resolveGroupPacks(packSize) {
      var listeners = getListenerQuantity();
      return listeners ? String(Math.ceil(listeners / packSize)) : 'Confirm';
    }

    function getRecommendedReceiverCount() {
      if (state.answers.listenerCount === '20_plus' || state.answers.listenerCount === '100_plus') return null;
      var listenerQuantity = getListenerQuantity();
      var capacity = state.answers.venueCapacity;
      var adaQuantity = state.answers.adaCompliance === 'yes' && typeof capacity === 'number' ? getAdaCounts(capacity).receivers : 0;
      return Math.max(listenerQuantity || 0, adaQuantity || 0) || null;
    }

    function getAdaReceiverTarget() {
      return state.answers.adaCompliance === 'yes' && typeof state.answers.venueCapacity === 'number' ? getAdaCounts(state.answers.venueCapacity).receivers : null;
    }

    function getM3AdaPlan() {
      var target = getAdaReceiverTarget() || 0;
      var compatibleTarget = typeof state.answers.venueCapacity === 'number' ? getAdaCounts(state.answers.venueCapacity).hearingAidCompatible : 0;
      var telecoilPacks = compatibleTarget ? Math.max(1, Math.ceil(compatibleTarget / 3)) : 0;
      var receiversAfterCoreAndTelecoil = 3 + (telecoilPacks * 3);
      var standardPacks = target > receiversAfterCoreAndTelecoil ? Math.ceil((target - receiversAfterCoreAndTelecoil) / 3) : 0;
      return { target: target, standardPacks: standardPacks, telecoilPacks: telecoilPacks, provided: receiversAfterCoreAndTelecoil + (standardPacks * 3) };
    }

    function getListenerQuantity() {
      var option = findListenerOption(state.answers.listenerCount);
      return option && typeof option.receiverQuantity === 'number' ? option.receiverQuantity : null;
    }

    function findListenerOption(value) {
      return config.listenerCounts.standard.concat(config.listenerCounts.group).find(function (option) { return option.value === value; });
    }

    function buildRequirementsSummary() {
      var useCase = findLabel(config.useCases, state.answers.useCase) || 'venue listening';
      var listener = findListenerOption(state.answers.listenerCount);
      var source = findLabel(config.audioSources, state.answers.audioSource);
      var barrier = findLabel(config.barriers, state.answers.barriers);
      var parts = [useCase];
      if (typeof state.answers.venueCapacity === 'number') parts.push(state.answers.venueCapacity.toLocaleString() + '-person maximum capacity');
      if (state.answers.adaCompliance === 'yes' && getAdaReceiverTarget()) parts.push(getAdaReceiverTarget() + '-receiver ADA capacity target');
      else if (listener) parts.push(listener.label + ' venue-provided devices');
      if (source && state.answers.audioSource !== 'not_sure') parts.push(source.toLowerCase());
      if (barrier && state.answers.barriers !== 'not_sure') parts.push(barrier.toLowerCase());
      var listening = formatListeningMethods();
      if (listening !== 'Not sure') parts.push(listening.toLowerCase());
      var hearingAids = formatHearingAidTypes();
      if (hearingAids !== 'Not specified') parts.push(hearingAids.toLowerCase());
      return parts.join(' · ') + '.';
    }

    function groupIcon(key) {
      if (key === 'transmitter') return '📡';
      if (key === 'receivers') return '🎧';
      return '🔌';
    }

    function getGroupWhy(key) {
      if (key === 'transmitter') return 'Carries your venue audio into the recommended broadcast system, matched to room size and separation.';
      if (key === 'receivers') {
        var copy = 'Provides the listening devices the venue can hand out.';
        if (state.rule && state.rule.id === 'ada-m3-up-to-two-hundred-seats') {
          var plan = getM3AdaPlan();
          copy += ' The 5403, 391 and 390 packs provide ' + plan.provided + ' receivers against the ' + plan.target + '-receiver ADA capacity reference.';
        }
        if (getHearingAidProfile() === 'newer') copy += ' Some newer Auracast hearing aids may receive directly, but compatibility must be checked by model.';
        return copy;
      }
      return 'Adds only the adapters triggered by the hearing-aid, Bluetooth or caption choices above.';
    }

    function joinReadable(values) {
      if (values.length < 2) return values[0] || 'the selected phone-based device';
      if (values.length === 2) return values[0] + ' and ' + values[1];
      return values.slice(0, -1).join(', ') + ', and ' + values[values.length - 1];
    }

    function findLabel(options, value) {
      var option = options.find(function (item) { return item.value === value; });
      return option ? option.label : '';
    }

    function getRecommendedProductIds(rule) {
      var groups = getResultGroups(rule);
      return groups.transmitter.concat(groups.receivers, groups.accessories).map(function (item) { return item.productId; });
    }

    function fetchRecommendedProducts() {
      var ids = Array.from(new Set(getRecommendedProductIds(state.rule)));
      Promise.all(ids.map(fetchProduct)).then(function () {
        var button = resultHost.querySelector('[data-add-all]');
        var availableCount = ids.filter(function (id) { return loadedProducts[id] && loadedProducts[id].variantId; }).length;
        if (!button) return;
        button.textContent = 'Add All to Cart';
        button.disabled = availableCount === 0;
        if (availableCount < ids.length) {
          var status = resultHost.querySelector('[data-cart-status]');
          if (status) status.textContent = 'Some items need expert confirmation or are not currently available online. Available recommendations can still be added to the cart.';
        }
      });
    }

    function fetchProduct(productId) {
      var product = config.products[productId];
      if (!product) return Promise.resolve(null);
      return fetch('/products/' + product.handle + '.js', { credentials: 'same-origin' })
        .then(function (response) { if (!response.ok) throw new Error('Product unavailable'); return response.json(); })
        .then(function (data) {
          var variant = (data.variants || []).find(function (item) { return item.available; }) || (data.variants || [])[0];
          loadedProducts[productId] = { variantId: variant ? variant.id : null, data: data };
          resultHost.querySelectorAll('[data-product-card="' + productId + '"]').forEach(function (card) {
            var title = card.querySelector('[data-product-title]');
            var image = card.querySelector('[data-product-image]');
            var price = card.querySelector('[data-product-price]');
            if (title && data.title) title.textContent = data.title;
            if (image && data.featured_image) {
              image.src = data.featured_image.indexOf('//') === 0 ? 'https:' + data.featured_image : data.featured_image;
              image.alt = data.title || product.fallbackTitle;
              image.hidden = false;
            }
            if (price && typeof data.price === 'number') price.textContent = formatMoney(data.price);
          });
          return data;
        })
        .catch(function () { loadedProducts[productId] = null; return null; });
    }

    function addAllToCart(groups) {
      var button = resultHost.querySelector('[data-add-all]');
      var status = resultHost.querySelector('[data-cart-status]');
      var quantities = {};
      groups.transmitter.concat(groups.receivers, groups.accessories).forEach(function (item) {
        var loaded = loadedProducts[item.productId];
        if (!loaded || !loaded.variantId) return;
        var variantId = String(loaded.variantId);
        quantities[variantId] = (quantities[variantId] || 0) + resolveCartQuantity(item.quantity);
      });
      var items = Object.keys(quantities).map(function (variantId) { return { id: Number(variantId), quantity: quantities[variantId] }; });
      if (!items.length) {
        status.textContent = 'No available products could be added. Please confirm this setup with an expert by email.';
        return;
      }
      button.disabled = true;
      button.textContent = 'Adding…';
      fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (response) {
        if (!response.ok) throw new Error('Cart request failed');
        track('solution_finder_cta_clicked', { cta_type: 'add_all_to_cart', item_count: items.length, result: state.rule ? state.rule.id : '' });
        window.location.assign('/cart');
      }).catch(function () {
        button.disabled = false;
        button.textContent = 'Add All to Cart';
        status.textContent = 'We could not add the setup to the cart. Please review the product links or confirm the setup by email.';
      });
    }

    function resolveCartQuantity(quantity) {
      var resolved = resolveQuantity(quantity);
      return /^\d+$/.test(resolved) ? Math.max(1, Number(resolved)) : 1;
    }

    function formatMoney(cents) {
      var currency = window.Shopify && window.Shopify.currency ? window.Shopify.currency.active : 'USD';
      try {
        return new Intl.NumberFormat(undefined, { style: 'currency', currency: currency }).format(cents / 100);
      } catch (error) {
        return '$' + (cents / 100).toFixed(2);
      }
    }

    function restart() {
      track('solution_finder_restarted', { previous_result: state.rule ? state.rule.id : '' });
      state.answers = state.presetUseCase ? { useCase: state.presetUseCase } : {};
      state.currentIndex = 0;
      state.completed = false;
      state.rule = null;
      state.attemptId = newAttemptId();
      saveSession();
      resultHost.hidden = true;
      questionCard.hidden = false;
      track('solution_finder_started', { start_source: 'restart', entry_page: window.location.pathname + window.location.search, use_case: state.answers.useCase || '', category: state.category || '' });
      renderQuestion();
      scrollToTool();
    }

    function setContextBadge() {
      var text = '';
      if (state.presetUseCase) text = 'Context: ' + findLabel(config.useCases, state.presetUseCase);
      else if (state.category) text = 'Entry context: ' + state.category.charAt(0).toUpperCase() + state.category.slice(1);
      contextBadge.textContent = text;
      contextBadge.hidden = !text;
    }

    function advisorUrl() {
      var email = root.getAttribute('data-expert-email') || 'support@venucast.com';
      return 'mailto:' + email + '?subject=' + encodeURIComponent('Please confirm my Venucast setup') + '&body=' + encodeURIComponent(buildSummary());
    }

    function buildSummary() {
      var lines = [
        'Attempt ID: ' + (state.attemptId || 'Not recorded'),
        'Use Case: ' + (findLabel(config.useCases, state.answers.useCase) || 'Not sure'),
        'Venue Capacity: ' + (typeof state.answers.venueCapacity === 'number' ? state.answers.venueCapacity : 'Not sure'),
        'ADA Sizing: ' + (state.answers.adaCompliance || 'Not sure'),
        'Receiver Target: ' + (getAdaReceiverTarget() || ((findListenerOption(state.answers.listenerCount) || {}).label || 'Not sure')),
        'Listeners: ' + formatListeningMethods(),
        'Hearing Aid Profile: ' + formatHearingAidTypes(),
        'Audio Source: ' + (findLabel(config.audioSources, state.answers.audioSource) || 'Not sure'),
        'Walls / Separation: ' + (findLabel(config.barriers, state.answers.barriers) || 'Not sure')
      ];
      if (state.rule) lines.push('Recommended Setup: ' + state.rule.recommendation.title);
      if (state.answers.notes) lines.push('Notes: ' + state.answers.notes);
      return lines.join('\n');
    }

    function formatListeningMethods() {
      if (!Array.isArray(state.answers.listeningMethod)) return 'Not sure';
      return state.answers.listeningMethod.map(function (value) { return findLabel(config.listeningMethods, value); }).filter(Boolean).join(' + ');
    }

    function formatHearingAidTypes() {
      var value = getHearingAidProfile();
      return value ? findLabel(config.hearingAidTypes, value) || 'Not specified' : 'Not specified';
    }

    function getHearingAidProfile() {
      if (Array.isArray(state.answers.hearingAidType)) return state.answers.hearingAidType[0] || '';
      return state.answers.hearingAidType || '';
    }

    function updateHelpLinks() {
      var summary = encodeURIComponent(buildSummary());
      root.querySelectorAll('[data-finder-help="ask_question"]').forEach(function (link) {
        var base = root.getAttribute('data-question-url') || '/pages/contact-us';
        link.href = base + (base.indexOf('?') === -1 ? '?' : '&') + 'source=solution_finder&finder_summary=' + summary;
      });
      root.querySelectorAll('[data-finder-help="book_call"]').forEach(function (link) {
        var base = root.getAttribute('data-book-call-url') || link.href;
        link.href = base + (base.indexOf('?') === -1 ? '?' : '&') + 'finder_summary=' + summary;
      });
    }

    function normalizeUseCase(value) {
      if (!value) return '';
      var normalized = value.toLowerCase().trim().replace(/[\s-]+/g, '_');
      var aliases = { assistive: 'assistive_listening', education: 'classroom', auditorium: 'theater', conference: 'meeting', tour: 'guided_tour', venue: 'distributed_audio' };
      normalized = aliases[normalized] || normalized;
      return config.useCases.some(function (item) { return item.value === normalized; }) ? normalized : '';
    }

    function normalizeTextParam(value) {
      if (!value) return '';
      return value.toLowerCase().replace(/[^a-z0-9_-]/g, '').slice(0, 40);
    }

    function normalizeEndpoint(value) {
      if (!value || !/^https:\/\//i.test(value)) return '';
      return value;
    }

    function newAttemptId() {
      return newUuid();
    }

    function newUuid() {
      if (window.crypto && typeof window.crypto.randomUUID === 'function') return window.crypto.randomUUID();
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (character) {
        var random = Math.floor(Math.random() * 16);
        var value = character === 'x' ? random : (random & 3) | 8;
        return value.toString(16);
      });
    }

    function saveSession() {
      try {
        sessionStorage.setItem(storageKey, JSON.stringify({ answers: state.answers, currentIndex: state.currentIndex, started: state.started, attemptId: state.attemptId }));
      } catch (error) {}
    }

    function restoreSession() {
      try {
        var saved = JSON.parse(sessionStorage.getItem(storageKey) || 'null');
        if (!saved) return;
        state.answers = saved.answers || {};
        state.currentIndex = Number.isInteger(saved.currentIndex) ? saved.currentIndex : 0;
        state.started = Boolean(saved.started);
        state.attemptId = saved.attemptId || '';
      } catch (error) {}
    }

    function track(eventName, properties, useBeacon) {
      var flow = getFlow();
      var payload = Object.assign({
        event_id: newUuid(),
        event: eventName,
        finder_version: config.version,
        attempt_id: state.attemptId || '',
        event_time: new Date().toISOString(),
        page_path: window.location.pathname,
        current_step: state.currentIndex + 1,
        current_question: flow[state.currentIndex] || 'complete'
      }, properties || {});
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(payload);
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        try { window.Shopify.analytics.publish(eventName, payload); } catch (error) {}
      }
      sendToLogEndpoint(payload, Boolean(useBeacon));
      document.dispatchEvent(new CustomEvent(eventName, { detail: payload }));
    }

    function sendToLogEndpoint(payload, useBeacon) {
      if (!logEndpoint) return;
      var body = JSON.stringify(payload);
      if (useBeacon && navigator.sendBeacon) {
        navigator.sendBeacon(logEndpoint, new Blob([body], { type: 'text/plain;charset=UTF-8' }));
        return;
      }
      fetch(logEndpoint, {
        method: 'POST',
        mode: 'cors',
        credentials: 'omit',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: body,
        keepalive: true
      }).catch(function () {});
    }

    function scrollToTool() {
      window.requestAnimationFrame(function () {
        tool.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
      });
    }
  }
})();
